var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi-sr-arrow-small-left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 10.5001H10.207L12.646 8.06113C12.9274 7.77986 13.0855 7.39834 13.0856 7.00048C13.0857 6.60262 12.9277 6.22102 12.6465 5.93963C12.3652 5.65823 11.9837 5.50009 11.5858 5.5C11.188 5.49991 10.8064 5.65786 10.525 5.93913L6.93896 9.52513C6.28373 10.1822 5.91577 11.0722 5.91577 12.0001C5.91577 12.928 6.28373 13.8181 6.93896 14.4751L10.525 18.0611C10.8064 18.3424 11.188 18.5003 11.5858 18.5003C11.9837 18.5002 12.3652 18.342 12.6465 18.0606C12.9277 17.7792 13.0857 17.3976 13.0856 16.9998C13.0855 16.6019 12.9274 16.2204 12.646 15.9391L10.207 13.5001H19C19.3978 13.5001 19.7793 13.3421 20.0606 13.0608C20.3419 12.7795 20.5 12.398 20.5 12.0001C20.5 11.6023 20.3419 11.2208 20.0606 10.9395C19.7793 10.6582 19.3978 10.5001 19 10.5001Z",
    fill: "#0B0E1D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.483a3a57591e800d1d76835ed7584e44.svg";
export { ForwardRef as ReactComponent };